export const calculateNights = (d1, d2) => {
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return numberOfNights;
  };

export const convertDateToString = (d) => new Date(d).toDateString();